module.exports = __webpack_public_path__ + "img/photo2_1.dd885ff0.jpg";